import { gql } from '@apollo/client';

const SUPPORT_CATEGORY_CACHE_REDIRECT_QUERY = gql`
  query SupportCategoryDetail($id: Int!) {
    supportCategoryDetail(id: $id) {
      title
    }
  }
`;

export default SUPPORT_CATEGORY_CACHE_REDIRECT_QUERY;
